import styles from './index.module.less';
interface PaginationProps {
  total: number;
  activeItem: {
    index: number;
    isEnd: boolean;
  };
  controllNum: number;
  oneBarWidth: number;
  onPageChange: (index: number) => void;
}

export const Pagination = ({
  total,
  controllNum = 3,
  oneBarWidth = 24,
  activeItem,
  onPageChange,
}: PaginationProps) => {
  const itemNumber = Math.ceil(total / controllNum);

  const isActived = (currentIndex: number) => {
    return (
      (!activeItem.isEnd &&
        Math.floor(activeItem.index / controllNum) === currentIndex) ||
      (activeItem.isEnd && currentIndex === itemNumber - 1)
    );
  };

  return (
    <div
      className={styles.pagination}
      style={{ width: itemNumber * oneBarWidth }}
    >
      {Array.from({ length: itemNumber }).map((_, index) => (
        <div key={index}>
          <div
            style={{ width: oneBarWidth }}
            className={
              isActived(index) ? styles['pagination__bullet--active'] : ''
            }
          />
          <div
            style={{ width: oneBarWidth }}
            className={styles['pagination__bullet--hidden']}
            onClick={() => {
              if (isActived(index)) {
                return;
              }
              onPageChange(index * controllNum);
            }}
          />
        </div>
      ))}
    </div>
  );
};
